import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19 19V3H5v16H3v2h18v-2h-2zm-8-6H9v-2h2v2z"
}), 'DoorBackSharp');